













import { defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import IconicListItem from '~/components/atoms/IconicListItem/IconicListItem.vue';
import { IconicListItemInterface } from '~/components/atoms/IconicListItem/IconicListItemTypes';

export default defineComponent({
  name: 'IconicList',
  components: {
    IconicListItem,
  },
  props: {
    items: {
      type: Array as PropType<Array<IconicListItemInterface>>,
      required: true,
    },
  },
});
